export default {
  getDiasSemana(state) {
    return state.diasSemana;
  },
  getHorarios(state) {
    return state.horarios;
  },
  getRelatorios(state) {
    return state.relatorios;
  },
  getDiaSemana(state) {
    // eslint-disable-next-line max-len
    return (diaAsNumber) => state.diasSemana.find((diaSemana) => diaSemana.value === diaAsNumber).label;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
};
